import React from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'

export default class AirTransportLicense extends React.Component {
  resource = '/air_transport_licenses'
  form_key = 'air_transport_license'
  defaults = {}

  // Delete lines as needed
//   fee           = 99
  free          = true
//   postpaid      = true
  skip_location = true
  hide_buttons  = false
  custom_actions = []

  validate = null

  foremost = null

  fields = form => [
    /*{
        name: 'i_am_applicant',
        label: 'I am applying for myself',
        type: 'select:bool'
    },
    {
        name: 'f_name',
        label: 'First Name',
        hide: form.i_am_applicant != false
    },
    {
        name: 'm_name',
        label: 'Middle Name',
        hide: form.i_am_applicant != false
    },
    {
        name: 'l_name',
        label: 'Last Name',
        hide: form.i_am_applicant != false
    },*/
    // "::Section (1)",
    // {
    //     name:'operator_f_name',
    //     label:'First Name of Operator or Carrier applying for Licence'
    // },
    // {
    //     name:'operator_m_name',
    //     label:'Middle Name of Operator or Carrier applying for Licence',
    //     required: false,
    // },
    // {
    //     name:'operator_l_name',
    //     label:'Last Name of Operator or Carrier applying for Licence'
    // },
    "::Particulars of President or CEO of Applicant",
    {
        name:'ceo_first_name',
        label:'First Name'
    },
    {
        name:'ceo_middle_name',
        label:'Middle Name',
        required: false,
    },
    {
        name:'ceo_last_name',
        label:'Last Name'
    },
    {
        name: 'ceo_birth_date',
        label: 'Date of Birth',
        type: 'date',
        showYearDropdown: true,
        //hide: form.i_am_applicant != false
    },
    {
        name: 'ceo_address',
        label: 'Present Address',
        // type:'textarea'
    },
    {
        name: 'ceo_passport_number',
        label: 'Passport Number',
        type:'passport'
    },
    {
        name:'ceo_nationality_proof',
        label:'Proof of Nationality',
        // type:'textarea'
    },
    {
        name:'ceo_nationality_proof_upload',
        label:'Proof of Nationality',
        type: 'file:all',
        key: 'iamge.0',
        // type:'textarea'
    },
    {
        name:'ceo_bio',
        label:'Professional Biography of President or CEO and names and position all key Management personnel - On letter head -',
        type:'textarea'
    },
    {
        name:'ceo_bio_upload',
        label:'Professional Biography of President or CEO and names and position all key Management personnel - On letter head -',
        type: 'file:all',
        key: 'iamge.1',
    },
    /*{
        name: 'passport_number',
        //hide: form.i_am_applicant != false
    },*/
    // {
    //     name: 'applicant_email',
    //     label: 'Email of applicant',
    //     type: 'email',
    //     //hide: form.i_am_applicant != false
    // },
    "::",
    {
        name: 'phone_numb',
        label:'Phone Contact of Applicant',
        type: 'phone'
    },

    "::Section (2)",
    {
        name: 'contact_details_list',
        label: 'Name and contact details of Local Representative retained in The Bahamas if applicable',
        required: false,
        fields: [
            {
                name: 'first_name'
            },
            {
                name: 'middle_name'
            },
            {
                name: 'last_name'
            },
            {
                name: 'phone_contact',
                label: 'Phone Number',
                type: 'phone'
            },
            {
                name: 'email',
                label: 'Email Address',
                type: 'email'
            }
        ]
    },
    /*
    //":: Scheduled Services",
    {
        name: 'registration_country',
        label: 'Aircraft Country of Registration',
        hide: form.license_type != 'scheduled'
    },
    {
        name: 'business_address',
        label: 'Registered business address',
        columns: ['Head office', 'In the Colony'],
        hide: form.license_type != 'scheduled'
    },
    {
        name: 'departure_point',
        label: 'Point of Departure',
        hide: form.license_type != 'scheduled'
    },
    {
        name: 'destination_point',
        label: 'Destination(Point)',
        hide: form.license_type != 'scheduled'
    },
    {
        name: 'intermaediate_landing',
        label: 'Intermediate landing points',
        hide: form.license_type != 'scheduled',
        rowLabel: 'Landing point',
        fields: [
            {
                name: 'traffic_purposes',
                label:'For traffic purposes'

            },
            {
                name: 'non_traffic',
                label:'For non-traffic purposes'
            }
        ]
    },
    {
        name: 'duration',
        options: ['1 Year', '2 Years'],
        hide: form.license_type != 'scheduled'
    },
    {
        name: 'seating_capacity',
        label: 'Type of Aircraft',
        hide: form.license_type != 'scheduled'
    },
    {
        name:'seating_capacity',
        label: 'Passenger Seating Capacity',
        hide: form.license_type != 'scheduled'
    },
    //"::Non-scheduled Services",
    {
        name: 'countries_list',
        label: 'List of Countries likely to be operated from when coming to The Bahamas.',
        type: 'textarea',
        hide: form.license_type != 'non-scheduled'
    },*/

    "::Section (3)",
    /*{
        name: 'nationality_proof_upload',
        label: "Proof of Nationality",
        type: 'file:all',
        key: 'iamge.0',
        hide: form.i_am_applicant != false
    },
    {
        name: 'professional_bio_upload',
        label: 'Professional Biography of President or CEO(including names and positions of all key management personnel)',
        type: 'file:pdf',
        key: 'image.1'
    },*/
    {
        name: 'insurance_cert_upload',
        label: 'Certificate of Insurance',
        type: 'file:all',
        key: 'iamge.2'
    },
    {
        name: 'airworthiness_cert_upload',
        label: 'Certifcate of Airworthiness',
        type: 'file:all',
        key: 'images.3'
    },
    {
        name: 'registration_cert_upload',
        label: 'Certificate of Registration',
        type: 'file:all',
        key:  'images.4'
    },
    {
        name: 'noise_cert_upload',
        label: 'Noise Certificate',
        type: 'file:all',
        key: 'image.5'
    },
    {
        name: 'radio_license_upload',
        label: 'Radio License',
        type: 'file:all',
        key: 'image.6'
    },
    {
        name: 'air_operator_cert_upload',
        label: 'Air Operator Certificate (AOC)',
        type: 'file:all',
        key: 'image.7'
    },
    {
        name: 'operator_specs_upload',
        label: "Complete Operator's/Air Carrier's Operations Specifications",
        type: 'file:all',
        key:'image.8'
    },
    {
        name: 'executive_summary_upload',
        label: 'Brief executive summary',
        type: 'file:all',
        key: 'image.9'
    },

    "::Section (4)",
    {
        name:'service_type',
        label:'The type of service applied for:',
        options:[
            { label: '(a) If Scheduled - proceed to Section(5)', value: 'scheduled' },
            { label: '(b) If Non-scheduled - proceed to section (6)', value: 'non-scheduled' }
        ]
    },

    "::Section (5)",
    {
        heading:<h5>SCHEDULED SERVICES</h5>
    },
    {
        heading:<p>Submit an accurate <strong>Time-Table</strong> for <strong>Scheduled Services, proposed passenger, freight, air mail conveyance rates, baggage allowance and excess baggage rates.</strong></p>
    },
    {
        name:'air_regist_country',
        label:'Aircraft Country of Registration'
    },
    {
        name:'regist_business_address_list',
        label:'Registered business address',
        fields:[
            {
                name:'Head Office'
            },
            {
                name:'In the Colony'
            }
        ]
    },
    {
        name:'route_particulars_list',
        label:'Particulars of Route desired to operate',
        fields:[
            {
                name:'Point of Departure'
            },
            {
                name:'Destination (Point)'
            },
        ]
    },
    {
        name:'inter_landing_points_list',
        label:'Intermediate landing points',
        fields:[
            {
                name:'traffic',
                label:'for traffic purposes'
            },
            {
                name:'non_traffic',
                label:'for non-traffic purposes'
            }

        ]
    },
    {
        name:'duration',
        label:'Duration of',
        options:['1 YEAR', '2 YEARS']
    },
    {
        name:'air_craft_type',
        label:'Type of aircraft',
        // hint:'Crew to be carried (number and function)',
        // type:'textarea'
    },
    {
        name:'air_craft_capacity',
        label:'Aircraft Passenger Seating Capacity',
        hint:'Crew to be carried (number and function)',
        // type:'textarea'
    },

    "::Section (6)",
    {
        heading:<h5>NON-SCHEDULED SERVICES.</h5>
    },
    {
        name:'country_list',
        label:'List of Countries likely to be operated from when coming to The Bahamas.',
        columns: ['country'],
        format: v => v.country,
    }
  ]

  render = () => <Wizard {...SERVICE_PROPS(this)} />
}
